import Carousel from './carousel'
import {
  AutoPlugin,
  DNLinksPlugin,
  DotsPlugin,
  // TouchPlugin,
  VisibilityPlugin
} from './plugins'

import ComponentManager from '../component-manager'

export const AutoCarousels = new ComponentManager(
  Carousel,
  '[data-js~=carousel]',
  () => ({
      plugins: [
        // VisibilityPlugin(),
        AutoPlugin({
          delay: 6000
        }),
        DotsPlugin(),
        // TouchPlugin(),
        DNLinksPlugin()
      ]
    })
);

export const EventCarousels = new ComponentManager(
  Carousel,
  '[data-js~=carousel-events]',
  () => ({
    plugins: [
      VisibilityPlugin(),
      AutoPlugin({
        delay: 6000
      }),
      DotsPlugin(),
      // TouchPlugin(),
      DNLinksPlugin()
    ]
  })
);


// WEBPACK FOOTER //
// ./scripts/components/carousels/index.js